import type { FeatureConfig } from '@platform/client/features';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'account/contacts',
      children: [
        {
          index: true,
          lazy: () => import('./pages/contacts/contact-list.page'),
        },
        {
          path: ':contactId',
          lazy: () => import('./pages/contact-id/contact-id.page'),
        },
        {
          path: 'new-contact',
          lazy: () => import('./pages/add-new-contact/add-new-contact.page'),
        },
      ],
    },
  ],
  navigation: () => ({
    orgProfile: {
      contacts: {
        title: i18n.t('contacts:navMenu'),
        segment: '/account/contacts',
      },
    },
  }),
} satisfies FeatureConfig;
